import CityPage from "../CityPage";

export default function NewLenox() {
  return <CityPage slug="new-lenox" />;
}
